import { ContentProps } from 'types';

const isProductCards = (content: ContentProps) => content.componentName === 'product_cards';

export default isProductCards;
